module.exports = __webpack_public_path__ + "img/Hatchback_Front.85331933.svg";